import { useEffect, useState } from 'react';
import CurrentMetricSelector from './CurrentMetricSelector';
import HistoricalMetricSelector from './HistoricalMetricSelector';
import HistoricalMetricSelectorV2 from './HistoricalMetricSelectorV2';
import CallbackMetricSelector from './CallbackMetricSelector';
import CCXCurrentMetricSelector from './CCXCurrentMetricSelector';
import CCXHistoricalMetricSelector from './CCXHistoricalMetricSelector';
import MiniSelector from './MiniSelector';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
  } from '@chakra-ui/react';

const MetricSelector = ({tempWidget, setTempWidget, symbeeStats, queues, ccxQueues}) => {
    
    const [metricSource, setMetricSource] = useState(null);
    
    useEffect(() => {
        console.log('temp widget: ', tempWidget);
        console.log(ccxQueues)
        for ( var i = 0; i < tempWidget?.arn.length; i++) {
            for (var q = 0; q < queues.length; q++) {
                if(queues[q]['arn'] === tempWidget?.arn[i]){
                    console.log('found source AWS');
                    setMetricSource('AWS');
                    return;
                } 
            }
            for (var z = 0; z < ccxQueues.length; z++) {
                 if(ccxQueues[z]['arn'] === tempWidget?.arn[i]){
                    console.log('found source SYBEE');
                    setMetricSource('SYMBEE');
                    return;
                }
            }
        }
        setMetricSource(null);
        
    }, [setMetricSource, tempWidget, ccxQueues, queues]);

    
    if(tempWidget.arn.length > 1) {
        return (
            <MiniSelector symbeeStats={symbeeStats} tempWidget={tempWidget} setTempWidget={setTempWidget}/>
        );
        
    } else {

        return (
            <Accordion allowToggle>
                {metricSource === 'AWS' ?
                    <>
                        <AccordionItem>
                            <h2>
                                <AccordionButton>
                                    <Box flex='1' textAlign='left'>
                                         Historical Metrics
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <HistoricalMetricSelector tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                            </AccordionPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <h2>
                                <AccordionButton>
                                    <Box flex='1' textAlign='left'>
                                         Historical Metrics V2
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <HistoricalMetricSelectorV2 tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                            </AccordionPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <h2>
                                <AccordionButton>
                                    <Box flex='1' textAlign='left'>
                                         Current Metrics
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <CurrentMetricSelector tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                            </AccordionPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <h2>
                                <AccordionButton>
                                    <Box flex='1' textAlign='left'>
                                         Callbacks
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <AccordionPanel pb={4}>
                                <CallbackMetricSelector tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                            </AccordionPanel>
                        </AccordionItem>
                    </>
                : null}
                {
                    symbeeStats && metricSource === 'SYMBEE' ?
                        <>
                            <AccordionItem>
                                <h2>
                                    <AccordionButton>
                                        <Box flex='1' textAlign='left'>
                                            Cornerstone CX Current Metrics
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                    <CCXCurrentMetricSelector tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                                </AccordionPanel>
                            </AccordionItem>
                            <AccordionItem>
                                <h2>
                                    <AccordionButton>
                                        <Box flex='1' textAlign='left'>
                                            Cornerstone CX Historical Metrics
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                    <CCXHistoricalMetricSelector tempWidget={tempWidget} setTempWidget={setTempWidget}/>
                                </AccordionPanel>
                            </AccordionItem>
                        </>
                    : null
                }
            </Accordion>
                
        );
    }

};

export default MetricSelector;



